import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Import Font Awesome icons

const AdminLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoader] = useState(false);
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility

const onSubmit = (e) => {
  e.preventDefault();
  setError('');
  setLoader(true);

  const { email, password } = formData;

  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  const raw = JSON.stringify({ email, password });

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  fetch('https://quran-backend-theta.vercel.app/v1/user/login', requestOptions)
    .then((response) => response.json())
    .then((data) => {
      if (data?.success === false) {
        setLoader(false);
        setError(data?.error || 'Login failed');
        return;
      }

      const user = data?.data?.userId;
      const token = data?.data?.token;

      // Allow only super-admin
      if (user?.role !== 'super-admin') {
        setLoader(false);
        setError('Access denied. Only super-admins are allowed.');
        return;
      }

      // Store data as if role is admin
      const modifiedUserData = {
        ...user,
        role: 'admin'  // Overwrite role for local usage
      };

      localStorage.setItem('userData', JSON.stringify(modifiedUserData));
      localStorage.setItem('token', token); // Store real token
      localStorage.setItem('role', 'admin'); // Treat as admin
      localStorage.setItem('loggedIn', true);

      setLoader(false);
      window.location.href = '/';
    })
    .catch((error) => {
      setLoader(false);
      setError('Server error or network failure');
    });
};


  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const isFormValid = formData.email && formData.password;

  return (
    <div className="bg-LoginBg bg-no-repeat bg-cover bg-white h-screen flex justify-center items-center">
      <div className="bg-white bg-opacity-85 w-full h-full flex justify-center items-center">
        <form
          onSubmit={onSubmit}
          className="shadow-2xl bg-white p-5 w-10/12 sm:w-8/12 md:w-6/12 lg:w-4/12 flex flex-col gap-5 rounded"
        >
          <div className="text-center">
            <h1 className="text-4xl font-bold">WELCOME QURAN INSTITUTE</h1>
          </div>

          <div>
            <label className="text-gray-400 font-semibold py-3">Username</label>
            <input
              type="email"
              name="email"
              className="w-full border bg-white mt-2 p-4 rounded-lg outline-none text-black"
              placeholder="Enter email..."
              value={formData.email}
              onChange={handleInputChange}
            />
          </div>

          <div>
            <label className="text-gray-400 font-semibold py-3">Password</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                className="w-full border bg-white mt-2 p-4 rounded-lg outline-none text-black pr-12"
                placeholder="Enter password..."
                value={formData.password}
                onChange={handleInputChange}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                className="absolute top-1/2 right-4 transform -translate-y-1/2 cursor-pointer text-gray-500"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>

          {error && <p className="text-red-500 text-center">{error}</p>}
          <div className="mb-4 mt-2 w-full">
            {loading ? (
              <button
                disabled
                type="button"
                className="bg-primary w-full text-center p-4 rounded-lg text-white uppercase font-semibold cursor-pointer"
              >
                <svg
                  aria-hidden="true"
                  role="status"
                  className="inline w-4 h-4 me-3 text-white animate-spin"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="#E5E7EB"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentColor"
                  />
                </svg>
                Loading...
              </button>
            ) : (
              <button
                type="submit"
                className={`bg-primary w-full text-center p-4 rounded-lg text-white uppercase font-semibold cursor-pointer ${
                  !isFormValid && 'opacity-50 cursor-not-allowed'
                }`}
                disabled={!isFormValid}
              >
                Login
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;